import { useState } from "react";
import { useGetProductsQuery } from "../../store/products/productsApi";
import { GridWrap } from "../ui/wrappers/GridWrap/GridWrap";
import LoadBlock from "../view/LoadBlock/LoadBlock";
import { TextError } from "../ui/errors/TextError/TextError";
import { StockItem } from "../view/StockItem/StockItem";
import { StockModal } from "../view/StockModal/StockModal";

export const Stock = () => {
  const {
    data: products,
    error,
    isLoading,
    refetch,
  } = useGetProductsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [editingProduct, setEditingProduct] = useState<string | undefined>(
    undefined,
  );
  const [editingProductName, setEditingProductName] = useState<
    string | undefined
  >(undefined);
  const [openModal, setOpenModal] = useState(false);

  const closeModal = () => setOpenModal(false);

  const editModal = (uuid: string, name: string) => {
    setEditingProduct(uuid);
    setEditingProductName(name);
    setOpenModal(true);
  };

  return (
    <>
      {isLoading ? (
        <LoadBlock />
      ) : error ? (
        <TextError text="Ошибка при загрузке" />
      ) : (
        <>
          <GridWrap>
            {products && products.length > 0
              ? products.map((item) => (
                  <StockItem
                    key={item.uuid}
                    item={item}
                    editAction={editModal}
                    updatePage={refetch}
                  />
                ))
              : null}
          </GridWrap>
        </>
      )}
      {openModal && editingProduct && (
        <StockModal
          productUuid={editingProduct}
          productName={editingProductName}
          closeModal={closeModal}
          updatePage={refetch}
        />
      )}
    </>
  );
};
